import { Box, Button, Switch } from "@mui/material";
import {
  DataGrid,
  gridClasses,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

/* ---------- Direction C tokens (styling only) ---------- */
const FONT = "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif";
const MONO = "'IBM Plex Mono', ui-monospace, monospace";
const INK = "#0F1B2A";
const INK_2 = "#3D4C60";
const MUTED = "#66748A";
const LINE = "#E4E9EF";
const PRIMARY = "#0B5C8A";

const UserInvites = () => {
  const [users, setUsers] = useState([]);
  const orgId = JSON.parse(localStorage.getItem("org"));
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  useEffect(() => {
    const getOrg = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/organization/get-by-admin?username=${storedUser.username}&orgId=${orgId}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
      );
      if (
        !res.data.orgLogo &&
        !res.data.orgUsername &&
        !res.data.orgShortform
      ) {
        navigate(`/dashboard/org-details`);
      }
    };
    getOrg();
  }, []);

  useEffect(() => {
    const getOrgUsers = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/membership/get-invites?orgId=${orgId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
        );
        setUsers(res.data);
      } catch (error) {
        console.log(error.response.data.Exception || "Access denied");
      }
    };
    getOrgUsers();
  }, []);

  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      renderCell: (params) => (
        <span style={{ fontWeight: 700, color: INK }}>{params.value}</span>
      ),
    },
    {
      field: "username",
      headerName: "Mobile No.",
      flex: 1,
      renderCell: (params) => (
        <span style={{ fontFamily: MONO, fontSize: 12.5, color: INK_2 }}>
          {params.row.user.countryCode != null ? `${params.row.user.countryCode}${params.row.user.username}` : params.row.user.username}
        </span>
      ),
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      renderCell: (params) => (
        <span style={{ color: INK_2 }}>{params.value}</span>
      ),
    },
    {
      field: "userRoleName",
      headerName: "User Role Name",
      flex: 1,
      renderCell: (params) => (
        <Box
          component="span"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 1.125,
            py: 0.25,
            borderRadius: "999px",
            background: "#EFEDFB",
            border: "1px solid #D3D0F2",
            color: "#4A3FBF",
            fontFamily: FONT,
            fontSize: 11.5,
            fontWeight: 700,
            lineHeight: 1.5,
            textTransform: "capitalize",
            whiteSpace: "nowrap",
          }}
        >
          {params.row.userRoleName.replace("_", " ").toLowerCase()}
        </Box>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      renderCell: (params) => (
        <Button
          variant="outlined"
          onClick={() => handleResend(params.row.user.username, params.row.user.countryCode)}
          sx={{
            minWidth: 0,
            height: 28,
            px: 1.25,
            borderRadius: "8px",
            border: "1px solid #D5DEE7",
            background: "#FFFFFF",
            color: INK,
            fontFamily: FONT,
            fontSize: 12.5,
            fontWeight: 600,
            textTransform: "none",
            "&:hover": { background: "#EAF2FB", borderColor: "#8FC3E6", color: "#1B4F82" },
          }}
        >
          Resend Invite
        </Button>
      ),
    },
  ];

  const handleResend = async (username, countryCode) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/org-user/resend`,
        {
          orgId: orgId,
          username: storedUser.username,
          countryCode: countryCode,
          mobile: username,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
      );
    } catch (error) {
      console.log(error)
    }
  }

  const rows = users ? users : "";

  const handleEnableDisable = async (orgUserId, isEnable) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/org-user?orgUserId=${orgUserId}`,
        {
          isEnable: !isEnable,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
      );
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div style={{ fontFamily: FONT, color: INK }}>
      <div className="dashboard-container" style={{ padding: 0, background: "transparent", boxShadow: "none" }}>
        <h1
          style={{
            margin: "8px 0 16px",
            fontFamily: FONT,
            fontSize: 27,
            fontWeight: 800,
            letterSpacing: "-0.028em",
            color: INK,
          }}
        >
          List of Invites
        </h1>
        <Box
          sx={{
            background: "#fff",
            border: `1px solid ${LINE}`,
            borderRadius: "14px",
            overflow: "hidden",
          }}
        >
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 20,
                },
              },
            }}
            pageSizeOptions={[20]}
            disableRowSelectionOnClick
            disableColumnSelector
            disableDensitySelector
            slots={{ toolbar: CustomToolbar }}
            getRowId={(row) => row.id}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
            }
            rowHeight={50}
            columnHeaderHeight={40}
            sx={{
              position: "relative",
              border: "none",
              fontFamily: `${FONT} !important`,
              color: INK,

              "& .MuiDataGrid-columnHeaderTitle": {
                fontFamily: FONT,
                fontWeight: "700 !important",
                fontSize: 10.5,
                letterSpacing: "0.09em",
                textTransform: "uppercase",
                color: MUTED,
              },
              "& .MuiDataGrid-columnHeaders": {
                background: "#F7F9FC !important",
                color: MUTED,
                fontSize: "14px",
                borderRadius: 0,
                borderTop: `1px solid ${LINE}`,
                borderBottom: `1px solid ${LINE}`,
              },
              "& .MuiDataGrid-columnHeader, & .MuiDataGrid-filler": {
                background: "#F7F9FC !important",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#F4F7FA",
              },
              "& .MuiDataGrid-cell": {
                fontSize: "13.5px",
                border: "none",
                borderBottom: "1px solid #F1F4F8",
                display: "flex",
                alignItems: "center",
              },
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus": {
                outline: "none",
              },
              "& .MuiDataGrid-columnSeparator": {
                display: "none",
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: `1px solid ${LINE}`,
              },
              "& .MuiTablePagination-root, & .MuiTablePagination-displayedRows": {
                fontFamily: MONO,
                fontSize: 12,
                color: MUTED,
              },
              "& .css-1ccsd5i-MuiButtonBase-root-MuiButton-root": {
                color: "#000 !important",
                border: "1px solid #B0B0B0",
                borderRadius: "12px",
                padding: 1,
              },
              "& .MuiInputBase-root-MuiInput-root::after": {
                borderBottom: "none !important",
              },
              "& .MuiInputBase-root-MuiInput-root": {
                borderBottom: "none !important",
              },
              [`& .${gridClasses.row}.even`]: {
                backgroundColor: "#FFFFFF",
                // '&:hover': {
                //   backgroundColor: "#f6f6f6",
                // },
              },
              [`& .${gridClasses.row}.odd`]: {
                backgroundColor: "#FCFDFE",
              },
              [`& .${gridClasses.row}.even:hover, & .${gridClasses.row}.odd:hover`]: {
                backgroundColor: "#F4F7FA",
              },
              "& .MuiInput-underline:before": {
                borderBottom: "none !important",
              },
              "& .MuiInput-underline:after": {
                borderBottom: "none !important",
              },
              "& .css-5h82ro-MuiInputBase-root-MuiInput-root::after": {
                borderBottom: "none !important",
              },
            }}
          />
        </Box>
      </div>
    </div>
  );
};

export default UserInvites;

function CustomToolbar() {
  return (
    <GridToolbarContainer
      sx={{ display: "flex", justifyContent: "end", px: 1.75, py: 1.25, gap: 1 }}
    >
      <GridToolbarQuickFilter
        sx={{
          border: "1px solid #D5DEE7",
          borderRadius: "9px",
          padding: "3px 10px",
          background: "#FFFFFF",
          "&:hover": {
            backgroundColor: "#F4F7FA",
          },
          "&:focus-within": {
            borderColor: PRIMARY,
          },
          "& .MuiInputBase-root": {
            borderRadius: "9px",
            fontFamily: FONT,
            fontSize: 13.5,
          },
          "& .MuiInputBase-root::before, & .MuiInputBase-root::after": {
            display: "none",
          },
          "& .MuiSvgIcon-root": { color: MUTED, fontSize: 18 },
          width: 300,
        }}
      />
      {/* <GridToolbarFilterButton /> */}
    </GridToolbarContainer>
  );
}
